import { render, staticRenderFns } from "./ListaDocumento.vue?vue&type=template&id=9e1df486"
import script from "./ListaDocumento.vue?vue&type=script&lang=js"
export * from "./ListaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports